import { render, staticRenderFns } from "./ContentHeading.vue?vue&type=template&id=844ffc46"
import script from "./ContentHeading.vue?vue&type=script&lang=js"
export * from "./ContentHeading.vue?vue&type=script&lang=js"
import style0 from "./ContentHeading.vue?vue&type=style&index=0&id=844ffc46&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_webpack@4.46.0__css-loader@3.6.0_webpack@4.46.0___96a47b7faf05f8ec6a90f2e68e8aca99/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports